import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
import ButtonMain from "../../../../common/components/button/ButtonMain";
import { ROUTE_PATH } from "../../../../config/CONSTANTS";
// store
// config,utils

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  width: "100%",
  paddingTop: "80px",
  paddingBottom: "80px",
  borderRadius: "16px",
  boxShadow: "0 15px 30px 0 rgba(180, 189, 207, 0.2)",
  backgroundColor: "#fff",
}));

const HomeCardLarge = ({
  title,
  subTitle,
  content,
  buttonText,
  onClickGoBtn,
  buttonHref,
}) => (
  // props

  // route,intl
  // store

  // local state
  // hooks

  <StyledBox>
    <Grid container justifyContent="center">
      <Grid item container justifyContent="flex-start" alignItems="center">
        {title && (
          <Grid item xs={12}>
            <Box mb={4}>
              <Typography
                variant="h4"
                textAlign="center"
                whiteSpace="nowrap"
                fontWeight={700}
                fontFamily="Noto Sans TC', sans-serif"
              >
                {title}
              </Typography>
            </Box>
          </Grid>
        )}
        {subTitle && (
          <Grid item xs={12}>
            <Box mb={4}>
              <Typography
                variant="h6"
                textAlign="center"
                whiteSpace="nowrap"
                fontWeight={500}
                fontFamily="Noto Sans TC', sans-serif"
              >
                {subTitle}
              </Typography>
            </Box>
          </Grid>
        )}
        {content && (
          <Grid item xs={12}>
            <Box mb={10}>
              <Typography variant="body1" textAlign="center">
                {content}
              </Typography>
            </Box>
          </Grid>
        )}
        {buttonText && (
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
              <ButtonMain
                buttonProps={{
                  text: buttonText,
                  onClick: onClickGoBtn,
                  size: "large",
                  href: buttonHref,
                }}
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </Grid>
  </StyledBox>
);

HomeCardLarge.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClickGoBtn: PropTypes.func,
  buttonHref: PropTypes.string,
};

HomeCardLarge.defaultProps = {
  title: "",
  subTitle: "",
  content: "",
  buttonText: "",
  onClickGoBtn: () => null,
  buttonHref: "",
};

export default HomeCardLarge;
